module.exports = __webpack_public_path__ + "static/media/product-9.bc4297b3.jpg";